<template>
  <div
    v-if="!cart.initial"
    class="ws-vue-cart-hijack top-menu-cart"
    :class="{ hidden: initialPlacement }"
  >
    <a
      href="javascript:void(0)"
      class="account-menu-cart"
      :class="{
        'account-menu-cart--empty':
          !get(cart, 'items.length') || checkoutInProgress,
        'cursor-not-allowed': checkoutInProgress,
      }"
      @click="navigateToCart"
    >
      <img class="account-menu-cart__icon" :src="cartIcon" alt="" height="17" />
      <!-- hide cart real state while checkout is in progress so less users clicks cart while waiting -->
      <div v-if="!checkoutInProgress" class="account-menu-cart__count">
        {{ get(cart, 'items.length') }}
      </div>
      <span class="account-menu-cart__label">{{ $t('cart.explicit') }}</span>
      <span v-if="!checkoutInProgress" class="account-menu-cart__total">{{
        $n(get(cart, 'summary.price.vatExcluded'), 'currency')
      }}</span>
    </a>
  </div>
  <div v-else class="ws-vue-cart-hijack top-menu-cart">
    <q-spinner class="q-mr-sm" />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { QSpinner } from 'quasar';

import { Cart } from '@/types';
import { isBrowser } from '@loopia-group/utils';
import { safePush } from '@/router';
import { logError } from '@/services/logger.service';
import cartIcon from '@/assets/images/cart.svg';
import {ROUTENAMES} from '@/consts/const.enum';

@Component({
  components: {
    QSpinner,
  },
  computed: {
    ...mapState(['cart', 'checkoutInProgress']),
  },
})
export default class TopMiniCart extends Vue {
  @Prop()
  readonly index!: number;
  @Prop()
  readonly templateCartEl!: HTMLElement;

  readonly cart!: Cart;
  checkoutInProgress!: boolean;
  initialPlacement = true;

  data() {
    return {
      cartIcon,
    };
  }

  mounted() {
    this.hijack(this.templateCartEl);
  }

  @Watch('templateCartEl', { immediate: true })
  hijack(templateCartEl: HTMLElement) {
    if (!isBrowser || !templateCartEl || !this.$el) {
      return;
    }

    if (templateCartEl.style.display === 'none') {
      // already hijacked, hot reload?
      return;
    }

    const parentNode = templateCartEl.parentNode;
    if (!parentNode) {
      // something went wrong, did someone change HF template?
      logError(`parentNode missing. parentNode: ${parentNode}`);
      return;
    }
    parentNode.insertBefore(this.$el, templateCartEl);

    templateCartEl.style.display = 'none';
    this.initialPlacement = false;
  }

  navigateToCart() {
    if (!this.checkoutInProgress) {
      safePush({ name: ROUTENAMES.CART });
    }
  }
}
</script>

<style lang="scss" scoped>
[v-cloak] {
  display: none;
}
</style>
